<template>
  <div class="main-page-wrapper p0 overflow-hidden">
    <!-- header start -->
    <HeaderTwo />
    <!-- header end -->

    <!-- hero area start -->
    <div class="clients-hero mt-100">
      <img src="../assets/images/icon/cross.svg" alt="" height="30" width="30" />
      <h1 class="">Our Clients</h1>
    </div>
    <!-- hero area end -->

    <logo-carousel />
    <gallery-video />
    <client-feedback />

    <!-- footer start -->
    <FooterSeven :dark_bg="true" :dark_btn="true" />
    <!-- footer end -->
  </div>
</template>

<script>
import HeaderTwo from '@/components/common/Headers/HeaderTwo.vue';
import ClientFeedback from "@/components/content/client-feedback.vue";
import FooterSeven from '@/components/common/Footers/FooterSeven.vue';
import LogoCarousel from "@/components/content/logo-carousel.vue";
import GalleryVideo from "@/components/content/gallery-video.vue";
import {useHead} from "@vueuse/head";

export default {
  name:'OurClients',
  components: {GalleryVideo, LogoCarousel, HeaderTwo, FooterSeven, ClientFeedback},
  created() {
    useHead({
      title: `Our Clients | Marshall Print`,
      meta: [
        {name: 'description', content: 'Clients'},
        {name: 'keywords', content: 'Clients'},
        // {property: 'og:title', content: 'Clients | Marshall Print'},
        // {property: 'og:description', content: 'The client list of Marshall Print'},
        // {property: 'og:image', content: ''},
      ]
    });
  }
}
</script>

<style lang="scss" scoped>
.clients-hero {
  background-color: var(--darkblue);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 2rem;
  padding: 6rem 0;
  @media (max-width: 991px) {
    gap: 1rem;
  }
  h1 {
    color: var(--white);
    font-size: 3rem;
    font-weight: 600;
    @media (max-width: 575px) {
      font-size: 2rem;
    }
  }
}
</style>
